const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/teams/team/$teamId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import type { ResourceFilterStatus } from '@/lib/api/types/teams';
import { getTeamQueryOptions } from '@/lib/queries/teams/useGetTeamQuery';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
const teamSearchSchema = z.object({
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED', 'ALL']).optional()
}) satisfies z.ZodType<{
  resourceStatus?: ResourceFilterStatus;
}>;
export const Route = createFileRoute('/(app)/org/$org/teams/team/$teamId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: teamSearchSchema,
  loader: async ({
    params: {
      teamId
    },
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    if (!teamId) {
      return {
        crumb: i18n.t('team', {
          ns: 'teams'
        })
      };
    }
    try {
      const teamData = await queryClient.ensureQueryData(getTeamQueryOptions({
        teamId: Number(teamId)
      }));
      const teamName = teamData?.team?.name || i18n.t('team', {
        ns: 'teams'
      });
      return {
        crumb: i18n.t('team', {
          ns: 'teams'
        }),
        dynamicTitle: teamName
      };
    } catch (_error) {
      // Error loading team data
      return {
        crumb: i18n.t('team', {
          ns: 'teams'
        })
      };
    }
  },
  pendingComponent: FullSizeSpinner
});